import curry from 'lodash/curry';

const filterCall = curry((obj, fn, data) => {
  return Object.entries(obj).every(([key, value]) => data[key] === value) && fn(data);
});

export { filterCall };
